import Strings from '../common/Strings';
import { sortWorkLogsByStartTimestamp } from './sort';

const moment = require('moment');

export function getLoggedTimeFromMillis(millis) {
  const minutes = Math.floor((millis / (1000 * 60)) % 60);
  const hours = Math.floor(millis / (1000 * 60 * 60));

  if (hours < 1) {
    if (minutes < 1) {
      return `${hours + Strings.COMMON.hoursShort}`;
    }
    return minutes + Strings.COMMON.minutesShort;
  } else if (hours === 1) {
    if (minutes === 0) {
      return `${hours + Strings.COMMON.hourShort}`;
    }
    return `${hours + Strings.COMMON.hourShort} ${minutes}${
      Strings.COMMON.minutesShort
    }`;
  }
  if (minutes === 0) {
    return `${hours + Strings.COMMON.hoursShort}`;
  }
  return `${hours + Strings.COMMON.hoursShort} ${minutes}${
    Strings.COMMON.minutesShort
  }`;
}

export function getLoggedTime(workLog) {
  return getLoggedTimeFromMillis(workLog.totalLoggedMillis);
}

export function getLoggedTimeFromHours(hours) {
  return getLoggedTimeFromMillis(hours * 1000 * 60 * 60);
}

export function getHoursFromMillis(millis, filterSecondsAndMilliseconds) {
  let millisToUse;
  if (filterSecondsAndMilliseconds) {
    millisToUse = dropSecondsAndMillisFromWorkLogMillis(millis);
  } else {
    millisToUse = millis;
  }
  return Number.parseFloat((millisToUse / (1000 * 60) / 60).toFixed(2));
}

export function dropSecondsAndMillisFromWorkLogMillis(millis) {
  return 1000 * 60 * parseInt(millis / (1000 * 60), 10);
}

export function getFormattedStartTimestamp(workLog) {
  if (workLog.startTimestamp) {
    return moment(workLog.startTimestamp).format('h:mm A');
  }
  return ' ';
}

export function getWorkLogBlocksByProject(workLogs) {
  const map = new Map();
  workLogs.forEach(w => {
    const existing = map.get(w.projectId);
    if (existing) {
      existing.totalLoggedMillis += dropSecondsAndMillisFromWorkLogMillis(
        w.totalLoggedMillis,
      );
      existing.workLogs.push(w);
    } else {
      const blockItem = {
        projectId: w.projectId,
        totalLoggedMillis: dropSecondsAndMillisFromWorkLogMillis(
          w.totalLoggedMillis,
        ),
        date: w.date,
        workLogs: [w],
      };
      map.set(w.projectId, blockItem);
    }
  });

  return [...map.values()];
}

export function getWorkLogsForProjectGraph(workLogs) {
  const map = new Map();
  workLogs.forEach(w => {
    const existing = map.get(w.date);
    if (existing) {
      existing.totalLoggedMillis += dropSecondsAndMillisFromWorkLogMillis(
        w.totalLoggedMillis,
      );
      existing.workLogs.push(w);
    } else {
      const blockItem = {
        projectId: w.projectId,
        totalLoggedMillis: dropSecondsAndMillisFromWorkLogMillis(
          w.totalLoggedMillis,
        ),
        date: w.date,
        workLogs: [w],
      };
      map.set(w.date, blockItem);
    }
  });

  return [...map.values()];
}

export function getWorkLogsSortedByStartTimestamp(workLogs) {
  const sortedWorkLogs = [].concat(workLogs);
  sortWorkLogsByStartTimestamp(sortedWorkLogs);
  return sortedWorkLogs;
}



// WEBPACK FOOTER //
// ./src/helpers/workLog.js